const translations = {
  de_DE: {
    email: 'E-Mail-Adresse',
    submit: 'Jetzt registrieren',
  },
}

export default translations
